/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import LoginPasswordTemplate from './LoginPassword.template';

import routeNames from 'lib/routeNames';
import groupSelectors from 'redux/reduxStore/group';

const mapStateToProps = (state) => {
  const group = groupSelectors.getActiveGroup(state);

  return {
    organizationName: group.organization_name || '',
  };
};

class LoginPassword extends React.Component {

  constructor(props) {
    super(props);

    this.submitPassword = this.submitPassword.bind(this);
    this.isPasswordGoodEnough = this.isPasswordGoodEnough.bind(this);

    this.state = {
      password: '',
      keepSignedIn: false,
    };
  }

  isPasswordGoodEnough() {
    return this.state.password.length > 0;
  }

  submitPassword() {
    if (!this.isPasswordGoodEnough()) { return; }

    this.props.submitCredentials({
      email: this.props.email,
      password: this.state.password,
      duration: 'short',
    });
  }

  render() {
    if (!this.props.email) { return <Redirect to={routeNames.loginEmail()} />; }
    if (this.props.requiresMfa) { return <Redirect to={routeNames.loginMfa()} />; }

    return (
      <LoginPasswordTemplate
        goBack={this.props.goBack}
        organizationName={this.props.organizationName}
        email={this.props.email}
        password={this.state.password}
        keepSignedIn={this.state.keepSignedIn}
        submitForm={this.submitPassword}
        groupName={this.props.groupName}
        updatePassword={(password) => {
          this.setState({ password });
          this.props.clearErrorMessage();
        }}
        toggleKeepSignedIn={() => { this.setState({ keepSignedIn: !this.state.keepSignedIn }); }}
        errorPhraseId={this.props.errorPhraseId}
        clearErrorMessage={this.props.clearErrorMessage}
        goToForgotPassword={routeNames.forgotPassword()}
        isPasswordGoodEnough={this.isPasswordGoodEnough()}
      />
    );
  }
}

export default connect(mapStateToProps)(LoginPassword);
